import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';


@Injectable()
export class AuthService
{
    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('access_token', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('access_token') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    userID(): number {
        this.accessToken =  localStorage.getItem('access_token');
        const us = AuthUtils.decodeToken(this.accessToken );
        return us['user_id'];
    }


    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(emailData: any): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', emailData);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(id: string, token: string, password: string): Observable<any>
    {
        return this._httpClient.post(`api/auth/update-reset-password/${id}/${token}`, { password });
    }


    validateEmail(userID: string, token: string ): Observable<any>
    {
        return this._httpClient.put(`api/auth/validate-email/${userID}/${token}`, {}, { observe: 'response' });
    }


    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string, password: string }): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post('api/auth/auth-admin/', credentials, { observe: 'response' }).pipe(
            switchMap((response: any) => {

                // Store the access token in the local storage
                this.accessToken = response.body.token;

                // Set the authenticated flag to true
                this._authenticated = true;

                const us = AuthUtils.decodeToken(this.accessToken );

                // const profile = await this.getPerfil();

                // Store the user on the user service
                // this._userService.user = response.user;
                this._userService.user = { id: us['user_id'], name: '', rolId: 1,
                    email: us['email'], rol: 'ROLE_ADMIN', roldes: 'ADMINISTRADOR'};

                // this.getProfile( dataSession )

                // Return a new observable with the response
                return of(response);
            })
        );
    }

    /**
     * Sign in using the access token // Originallll
     */
     signInUsingToken(): Observable<any>
     {
        this.accessToken =  localStorage.getItem('access_token');
         // this.accessToken = response.access_token;
        const us = AuthUtils.decodeToken(this.accessToken );
        this._authenticated = true;

        this._userService.user = { id: us['idUser'], name: '', rolId: us['rol_id'],
        email: us['sub'], rol: us['rol'], roldes: us['rol_descripcion']};

        return of(true);
     }


    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        // Remove the access token from the local storage
        localStorage.removeItem('access_token');

        // Set the authenticated flag to false
        this._authenticated = false;


        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { first_name: string, last_name: string, email: string, password: string, degree: string }): Observable<any>
    {
        return this._httpClient.post('api/user-nutritionis', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string, password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }

        // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            return of(false);
        }

        // If the access token exists and it didn't expire, sign in using it
        return this.signInUsingToken();
    }
}
